import { lazy, Suspense } from 'react';

import ErrorBoundary from '@apigrowfinance/pbolt-error-boundary';
import GlobalLoader from '@apigrowfinance/pbolt-global-loader';
import { FormattedMessage } from 'react-intl';

import { useAccount } from '@contexts/AccountProvider';

const LendingApp = lazy(() => import('./LendingApp'));

const SuspendedLendingApp = ({ basename }: { basename: string }) => {
    const { account, isLoading } = useAccount();
    if (isLoading) {
        return <>loading</>;
    }
    return (
        <ErrorBoundary
            title={
                <FormattedMessage
                    id="suspendedLendingApp.errorTitle"
                    defaultMessage="An Error Occurred"
                />
            }
            message={
                <FormattedMessage
                    id="suspendedLendingApp.error"
                    defaultMessage="Failed to load lending micro frontend. Are you sure it's running?"
                />
            }>
            <Suspense fallback={<GlobalLoader />}>
                <LendingApp
                    basename={`/accounts/${account?.account_id}/${basename}`}
                />
            </Suspense>
        </ErrorBoundary>
    );
};

export default SuspendedLendingApp;
